module.exports = __webpack_public_path__ + "static/media/hw_u_3.d8d207df.flv";